import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const ToDateNumbers = ( { data } ) => {
    return (
        ( data ) ? (
            <Container fluid>
                <Row className='text-center'>
                {
                    data.map( ( d, idx ) => (
                        <Col key={`${d.label}-${idx}`}>
                            <Row>
                                <Col className='tf-todate-value'>{d.value}</Col>
                            </Row>
                            <Row>
                                <Col className='tf-todate-label'>{d.label}</Col>
                            </Row>
                        </Col>
                    ) )
                }
                </Row>
            </Container>
        ) : (
            null
        )
    );
}

export default ToDateNumbers;